import { QuickActionSchema } from '../../lib';
import { IResponse } from '../../domains/types';

export interface IGetUserOrgResponse extends IResponse<IUserOrganization> {}

export interface IUserOrganization {
  id: string;
  createdBy: string;
  displayName: string;
  phoneNumber: string;
  preferredLanguage: string;
  region: string;
  accountId?: string;
}

export enum EAppAccess {
  'User' = 'User',
  'Admin' = 'Admin',
  'Viewer' = 'Viewer',
  'Tech Admin' = 'Tech Admin',
  'Developer' = 'Developer',
  'Read only' = 'Read only',
  'Analytics user' = 'Analytics user',
}

export type AppAccess = QuickActionSchema['appAccess'];

export enum EOrgAccess {
  'Organization Admin' = 'Organization Admin',
  'Organization Owner' = 'Organization Owner',
  'Organization User' = 'Organization User',
}

export type OrgAccess =
  | 'Organization Admin'
  | 'Organization Owner'
  | 'Organization User';

export interface IUser {
  id: string;
  email: string;
  emailVerified: boolean;
  created: string;
  updated: string;
  lastLogin: string;
  signUpCompleted: boolean;
  givenName: string;
  familyName: string;
  nickName: string;
  phoneNumber: string;
  company: string;
  jobRole: string;
  preferredLanguage: string;
  region: string;
  isExternal?: boolean;
}

export interface IUpdateUserData extends Partial<IUser> {
  id: string;
  password?: string;
}

// TODO add this later
// export type IUserRole =
//   | {
//       organizationId: string;
//     }
//   | {
//       scope: 'Organization';
//       role: EOrgAccess;
//       tenantId: null;
//     }
//   | {
//       scope: string;
//       role: EAppAccess;
//       tenantId: string;
//     };

export interface IUserRole {
  organizationId: string;
  tenantId: string | null;
  role: string;
  scope: string;
}

export interface IGetUserRole extends IResponse<IUserRole> {}

export interface IUserOrg {
  id: string;
  createdBy: string;
  displayName: string;
  phoneNumber: string;
  preferredLanguage: string;
  region: string;
  accountId?: string;
}

export interface IGetUserOrg {
  totalCount: number;
  pageSize: number;
  pageNumber: number;
  data: IUserOrg[];
}

export interface IGetUserRole {
  totalCount: number;
  pageSize: number;
  pageNumber: number;
  data: IUserRole[];
}
